export const SUPPORTED_LANGUAGES = {
    panel: ['lt', 'en', 'ru', 'tr', 'pl'],
    admin: ['en', 'lt', 'tr'],
};
export function t(dict, source, vars = {}) {
    const template = dict[source] || source;
    return template.replace(/\{([A-Za-z_][A-Za-z_0-9]*)\}/g, (placeholder, name) => Object.hasOwn(vars, name) ? String(vars[name]) : placeholder);
}
//# sourceMappingURL=index.js.map